export default {"src":"/_next/static/media/docEtDent75Details.899fad19.svg","height":206,"width":440,"blurWidth":0,"blurHeight":0};